export default __webpack_public_path__ + "static/media/login_logo.c2fa189b.png";